type CalendarEvent = { title: string; startISO: string; durationMinutes: number }

const fmt = (d: Date) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')

function range({ startISO, durationMinutes }: CalendarEvent) {
  const start = new Date(startISO)
  const end = new Date(start.getTime() + durationMinutes * 60000)
  return { start, end }
}

/** Builds and downloads a minimal .ics calendar file. */
export function downloadIcs(event: CalendarEvent) {
  const { start, end } = range(event)
  const ics = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//BCITI ATNA//Formation//FR',
    'BEGIN:VEVENT',
    `UID:${fmt(start)}-formation@bciti.ai`,
    `DTSTAMP:${fmt(new Date())}`,
    `DTSTART:${fmt(start)}`,
    `DTEND:${fmt(end)}`,
    `SUMMARY:${event.title}`,
    'DESCRIPTION:Le lien de connexion vous est envoyé par courriel. / The meeting link is sent to you by email.',
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n')
  const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }))
  const a = document.createElement('a')
  a.href = url
  a.download = 'formation-communications-atna.ics'
  a.click()
  URL.revokeObjectURL(url)
}

/** Google Calendar "add event" link. */
export function googleCalendarUrl(event: CalendarEvent) {
  const { start, end } = range(event)
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.title,
    dates: `${fmt(start)}/${fmt(end)}`,
    details: 'Le lien de connexion vous est envoyé par courriel. / The meeting link is sent to you by email.',
  })
  return `https://calendar.google.com/calendar/render?${params.toString()}`
}
